module.exports = __webpack_public_path__ + "img/matcha-latte.7f56f0e2.jpg";